import type { Direction } from "@repo/ui/constants/directions";
import { DIRECTIONS, DIRECTIONS_LIST } from "@repo/ui/constants/directions";

export const getDirection = (index?: number): Direction => {
  if (index == null || index < 0) {
    return DIRECTIONS.OUTBOUND;
  }

  return DIRECTIONS_LIST[index] ?? DIRECTIONS.OUTBOUND;
};
